import React, { useState } from "react";
import axios from "./../../../utils/axiosInstance";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";

function VerifyEmail() {
  const [searchParams, setSearchParams] = useSearchParams();
  const userType = searchParams.get("userType");
  const [verificationCode, setVerificationCode] = useState("");

  const email = localStorage.getItem("emailForVerification");
  const handleVerify = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASED_URL}/auth/verifyEmail`,
        {
          email: email,
          verificationCode: verificationCode,
        }
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        // Redirect to login page or dashboard
        window.location.href = "/dashboard";
        localStorage.setItem("token", response.data.token);
      } else {
        toast.error(response.data.message);
        window.location.href = "/login";
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    }
  };

  return (
    <div className="container mx-auto flex justify-center items-center h-screen bg-gray-100">
      <div className="bg-white shadow-md rounded-lg w-96 p-8">
        <h2 className="text-center text-2xl font-bold mb-4">
          Verify Your Email
        </h2>
        <p className="text-gray-600 text-center mb-6">
          Enter the verification code sent to your email.
        </p>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2" htmlFor="code">
            Verification Code
          </label>
          <input
            type="text"
            className="block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            placeholder="Enter verification code"
          />
        </div>
        <button
          onClick={handleVerify}
          className="text-white bg-blue-700 hover:bg-blue-800 rounded px-4 py-2 w-full"
        >
          Verify Now
        </button>
      </div>
    </div>
  );
}

export default VerifyEmail;
